import { readDevicePreference, writeDevicePreference } from '@/lib/device-preferences';
import { isSpeechLanguage, type SpeechLanguage } from './speech/language';

/**
 * Dictation's preferences on this device: the language a voice call transcribes the user in,
 * through their `realtime.v1` provider.
 */
export type DictationSettings = {
  speechLanguage: SpeechLanguage | 'system';
};

const KEY = 'crowdex.dictation';

function dictationSettingsFromValues(values: Readonly<Record<string, unknown>>): DictationSettings {
  const language = values['speechLanguage'];
  return {
    speechLanguage:
      typeof language === 'string' && isSpeechLanguage(language) ? language : 'system',
  };
}

export function readDictationSettings(): DictationSettings {
  try {
    return dictationSettingsFromValues(JSON.parse(readDevicePreference(KEY) ?? '{}'));
  } catch {
    return dictationSettingsFromValues({});
  }
}

export function writeDictationSettings(settings: DictationSettings): Promise<void> {
  return writeDevicePreference(KEY, JSON.stringify(settings));
}
